/**
 * The logo project card dom unique identifier attribute
 * @type {String}
 */
export const PROJECT_CARD_DOM_ID_ATTRIBUTE = 'data-project-id';

/**
 * The project card class name
 * @type {String}
 */
export const PROJECT_CARD_CLASSNAME = 'logo-project-card';

/**
 * Favorite project card class names.
 * @type {string}
 */
export const FAVORITE_PROJECT_CARD_CLASSNAME = `${PROJECT_CARD_CLASSNAME} favorite-container`;

/**
 * Specific variation dom unique identifier attribute
 * @type {String}
 */
export const VARIATION_DOM_ID_ATTRIBUTE = 'data-variation-id';

/**
 * Maximum width of one variation preview card.
 * @type {Object}
 */
export const MAX_PREVIEW_WIDTH = {
    DESKTOP: 32,
    TABLET: 44
};

/**
 * Paddings on the sides of logo project card container.
 * @type {number}
 */
export const CONTAINER_PADDINGS = 12 * 2;

/**
 * Paddings size per one variation preview card.
 * @type {number}
 */
export const PREVIEW_PADDING = 4;
